import { createGlobalState } from 'react-use';

const copyModal = createGlobalState(false);
const deleteModal = createGlobalState(false);
const saveModal = createGlobalState(false);
const usageModal = createGlobalState(false);

export enum SnippetModals {
  Copy = 'copy',
  Delete = 'delete',
  Save = 'save',
  Usage = 'usage',
}

export function useSnippetModals() {
  const [showCopyModal, setShowCopyModal] = copyModal();
  const [showDeleteModal, setShowDeleteModal] = deleteModal();
  const [showSaveModal, setShowSaveModal] = saveModal();
  const [showUsageModal, setShowUsageModal] = usageModal();

  return {
    [SnippetModals.Copy]: {
      isShown: showCopyModal,
      toggle: (newState?: boolean) => {
        setShowCopyModal(newState ?? !showCopyModal);
      },
    },

    [SnippetModals.Delete]: {
      isShown: showDeleteModal,
      toggle: (newState?: boolean) => {
        setShowDeleteModal(newState ?? !showDeleteModal);
      },
    },

    [SnippetModals.Save]: {
      isShown: showSaveModal,
      toggle: (newState?: boolean) => {
        setShowSaveModal(newState ?? !showSaveModal);
      },
    },

    [SnippetModals.Usage]: {
      isShown: showUsageModal,
      toggle: (newState?: boolean) => {
        setShowUsageModal(newState ?? !showUsageModal);
      },
    },
  };
}
